<p-multiSelect #multiSelect [(ngModel)]="selectedCodes" size="small" [options]="options" [optionLabel]="optionLabel"
  [optionValue]="optionValue" [placeholder]="placeholder" [filter]="false" display="chip" [disabled]="disabled"
  (ngModelChange)="onSelect($event)" [showToggleAll]="false" [showClear]="showClear" class="w-full md:w-80"
  (onFocus)="announceSelectedValue()" [ariaLabel]="ariaLabel" (onBlur)="ariaMessage=''">

  <ng-template pTemplate="selectedItems" let-selected>
    <ng-container *ngIf="selected?.length; else placeholderTpl">
      <ng-container *ngFor="let item of selected?.slice(0, maxTagCount)">
        <div class="p-multiselect-token">
          <span class="p-multiselect-token-label">
            {{ getLabel(item) }}
          </span>
          <span class="pi pi-times-circle p-multiselect-token-icon" (click)="remove(item)" tabindex="0"
            (keydown.enter)="remove(item)" (keydown.space)="remove(item)" role="button" attr.aria-label="Remove {{getLabel(item)}}"></span>
        </div>
      </ng-container>
      <ng-container *ngIf="selected.length > maxTagCount">
        <div class="p-multiselect-token">
          <span class="p-multiselect-token-label">
            +{{ selected.length - maxTagCount }} more
          </span>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #placeholderTpl>
      <span class="p-placeholder">{{ placeholder }}</span>
    </ng-template>
  </ng-template>


  <ng-template let-option pTemplate="item">
    <div class="option-row">
      <span>{{ option[optionLabel] || option }}</span>
      <span *ngIf="isSelected(option)" class="checkmark-icon">
        <svg viewBox="64 64 896 896" focusable="false" fill="currentColor" width="1em" height="1em" data-icon="check"
          aria-hidden="true">
          <path
            d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z">
          </path>
        </svg>
      </span>
    </div>
  </ng-template>
</p-multiSelect>
<div aria-live="assertive" class="sr-only">
  {{ariaMessage}}
</div>